export const removeOldDuplicatesBy = <T>(
  data: T[],
  getId: (entry: T) => string,
): T[] => {
  const entriesMap = new Map<string, T>();

  data.forEach((current) => {
    const id = getId(current);
    entriesMap.set(id, current);
  });

  return Array.from(entriesMap.values());
};
